import {createFileRoute, redirect} from "@tanstack/react-router";

// /w/$workspaceId/adgpt/chats → start a fresh chat when no id was supplied.
export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_adgptScaffold/adgpt/chats/",
)({
    loader: ({params}) => {
        throw redirect({
            to: "/w/$workspaceId/adgpt/chats/$chatId",
            params: {workspaceId: params.workspaceId, chatId: "new"},
            replace: true,
        });
    },
});
